<template>
    <v-card class="card--flex-toolbar">
        <v-toolbar card prominent>
            <v-toolbar-title class="body-2 grey--text">{{$t('rms.uploader.title')}}</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-container fluid>
            <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" :useCustomSlot="true">
              <div class="dropzone-custom-content">
                <v-icon color="blue-grey lighten-4" style="font-size: 70px">mdi-cloud-upload</v-icon>
                <h2 color="info" class="dropzone-custom-title">{{$t('rms.drag_and_drop.message')}}</h2>
                <div class="subtitle">{{$t('rms.drag_and_drop.subtitle')}}</div>
              </div>
            </vue-dropzone>
        </v-container>
        <v-btn color="info" @click="$router.go(-1)">Back</v-btn>
    </v-card>
</template>

<script>
import {buildHeaders} from '../../api/_manager';
import * as API from '../../api/_manager';
// import from local copy
import vue2Dropzone from '@/components/local/vue2-dropzone/src/index.js';
import '@/components/local/vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  name: "FilmUploader",
  components: {
    vueDropzone: vue2Dropzone
  },
  computed: {
    dropzoneOptions() {
      let company_id = this.$route.params.company_id
      let film_id = this.$route.params.film_id
      return {
          url: this.DEFINES.BASE_API_URL+'/member/company/'+company_id+'/film/'+film_id+'/upload',
          thumbnailWidth: 200,
          maxFilesize: 1024,
          chunking: true,
          chunkSize: 1000000, // Bytes
          addRemoveLinks: true,
          headers: buildHeaders().headers
      }
    }
  },
};
</script>
<style scoped>
  .dash-border {
    border: 2px solid lightgrey;
    border-radius: 25px
  }
</style>


